import React from "react";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { useTranslation } from "react-i18next";

interface NuxSearchFieldProps {
    value: string;
    onSearch: (searchText: string) => void;
}

const NuxSearchField = ({ value, onSearch }: NuxSearchFieldProps) => {
    const { t } = useTranslation();
    const handleClear = () => {
        onSearch("");
    };

    return (
        <Paper
            component="form"
            variant="outlined"
            onSubmit={(event) => event.preventDefault()}
            sx={{
                p: "2px 4px",
                display: "flex",
                alignItems: "center",
                width: "100%",
                borderRadius: "25px",
            }}
        >
            <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
                <SearchIcon />
            </IconButton>
            <InputBase
                sx={{ ml: 1, flex: 1 }}
                placeholder={t("searchFor", { ns: "nux" })}
                inputProps={{ "aria-label": t("searchFor", { ns: "nux" }) }}
                value={value}
                onChange={(event) => onSearch(event.currentTarget.value)}
            />
            {value && (
                <IconButton
                    type="button"
                    sx={{ p: "10px" }}
                    aria-label={t("clearSearch", { ns: "nux" })}
                    onClick={handleClear}
                >
                    <ClearIcon />
                </IconButton>
            )}
        </Paper>
    );
};

export default NuxSearchField;
